import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCqREXT2R7HP_oPyIM8JomEe3qgIB3w_XQ",
  authDomain: "idzuo-3d47a.firebaseapp.com",
  projectId: "idzuo-3d47a",
  storageBucket: "idzuo-3d47a.firebasestorage.app",
  messagingSenderId: "24048256531",
  appId: "1:24048256531:web:60040178eba9bc1ba621e6"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);